import { render, staticRenderFns } from "./academicInfo.vue?vue&type=template&id=ba901136&scoped=true"
import script from "./academicInfo.vue?vue&type=script&lang=js"
export * from "./academicInfo.vue?vue&type=script&lang=js"
import style0 from "./academicInfo.vue?vue&type=style&index=0&id=ba901136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba901136",
  null
  
)

export default component.exports